import { Title } from "@smartsuite/react-ui/lib/components/typography/Title/Title";
import { Scrollbar } from "@smartsuite/react-ui/lib/components/utils/Scrollbar/Scrollbar";

import { Paragraph } from "@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph";
import { TextFieldGroup } from "@smartsuite/react-ui/lib/components/forms/TextFieldGroup/TextFieldGroup";
import { useInputGroupState } from "@smartsuite/react-ui/lib/hooks/useInputGroupState/useInputGroupState";
import { useState } from "react";
import { Field } from "../../api/types";
import { SidebarFieldButton } from "../SidebarFieldButton/SidebarFieldButton";
import { fieldTypeIcons } from "../global.constants";
import { GrayColors } from "@smartsuite/types";

export interface SidebarFieldListProps {
  fields: Field[];
  onClick: (field: Field) => void;
}

export const SidebarFieldList: React.FC<SidebarFieldListProps> = ({
  fields,
  onClick,
}) => {
  const [search, setSearch] = useState("");
  const {
    state: searchState,
    onFocus: onSearchFocus,
    onBlur: onSearchBlur,
  } = useInputGroupState();

  const filteredFields = fields.filter((field) =>
    field.label.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="sidebar-field-list">
      <Scrollbar
        gutterTop={4}
        gutterRight={2}
        gutterBottom={4}
        noScrollX
        style={{ width: "100%", height: "100%" }}
      >
        <div className="sidebar-field-list__body">
          <Title
            weight="medium"
            size="xs"
            className="sidebar-field-list__title"
          >
            Fields
          </Title>

          <div className="sidebar-field-list__search">
            <TextFieldGroup
              icon={{
                name: "search",
                color: GrayColors["G-4"],
                position: "left",
              }}
              placeholder="Search Fields"
              value={search}
              inputGroupState={searchState}
              onChangeValue={setSearch}
              onFocus={onSearchFocus}
              onBlur={onSearchBlur}
            />
          </div>

          <div className="sidebar-field-list__items">
            {filteredFields.length === 0 && (
              <Paragraph size="s" color="secondary">
                No fields found
              </Paragraph>
            )}

            {filteredFields
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((field) => (
                <SidebarFieldButton
                  key={field.slug}
                  iconName={fieldTypeIcons[field.field_type]}
                  iconSize="S"
                  label={field.label}
                  fieldType={field.field_type}
                  onClick={() => onClick(field)}
                />
              ))}
          </div>
        </div>
      </Scrollbar>
    </div>
  );
};
